import React from "react";

import DestinationSectorCellContent from "../components/DestinationSectorCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function destinationSector({ width, language, onResize }: Column.Options) {
	return base(
		ColumnId.DestinationSector,
		(item) => (
			<DestinationSectorCellContent item={item} language={language} />
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default destinationSector;
